import * as h2Api from '../../h2Api'
import * as profileActions from '../../actions/military'
import { handleReducingJournalForItem } from '../../actions'
import { POPUP_JOURNAL_COMPLETION } from '../../actions/journals'

const initialState = {
  selectedProfile: {},
  profileCache: {},
  localOpportunitiesLoading: false,
  selectedLocalTab: 5
}
const militaryProfile = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.RATE_MOC:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: {
            ...state.selectedProfile,
            personalization: {
              ...state.selectedProfile.personalization,
              ...p
            }
          }
        }
      }

      return state

    case profileActions.MILITARY_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: p
        }
      }

      return state

    case POPUP_JOURNAL_COMPLETION:
      return handleReducingJournalForItem(action, state, 'selectedProfile')

    default:
      return state
  }
}

export default militaryProfile
